import { make } from 'redux-chill';

const setReviewInfo = make('[delivery] set review info').stage('reset');

export { setReviewInfo };
